<template>
  <div>
    <rest-form-item
      prop="utm_params"
      :hint="$t('UrlTracking_UrlParams_UtmParams_Description')"
    >
      <toggle
        v-model="model.utm_params"
        :disabled="disabled"
        :text="$t('UrlTracking_UrlParams_UtmParams_Switch')"
      />
    </rest-form-item>

    <el-table
      v-if="model.utm_params"
      :data="utmParamsList"
      class="utm-params-list"
      :class="{ disabled: disabled }"
      :show-header="false"
      stripe
    >
      <el-table-column prop="key" :width="120" />
      <el-table-column prop="value" />
    </el-table>

    <rest-form-item
      prop="custom_params"
      :hint="$t('UrlTracking_UrlParams_CustomParams_Description')"
    >
      <toggle
        v-model="model.use_custom_params"
        :disabled="disabled"
        :text="$t('UrlTracking_UrlParams_CustomParams_Switch')"
      />
    </rest-form-item>

    <div v-if="model.use_custom_params" class="custom-params-list">
      <el-row v-for="(param, index) in model.params" :key="index">
        <el-col :span="11">
          <rest-form-item
            :prop="'params.' + index + '.key'"
            :rules="{
              required: true,
              trigger: 'blur',
              message: $t('UrlTracking_UrlParams_Key_Required_Msg')
            }"
          >
            <el-input
              v-model="param.key"
              placeholder="key"
              :disabled="disabled"
            />
          </rest-form-item>
        </el-col>

        <el-col :span="11">
          <rest-form-item
            :prop="'params.' + index + '.value'"
            :rules="{
              required: true,
              trigger: 'blur',
              message: $t('UrlTracking_UrlParams_Value_Required_Msg')
            }"
          >
            <el-input
              v-model="param.value"
              placeholder="value"
              :disabled="disabled"
            />
          </rest-form-item>
        </el-col>

        <el-col :span="2">
          <el-link
            v-if="!readonly"
            icon="el-icon-close"
            @click="removeParam(index)"
            :underline="false"
            class="remove-button"
            :disabled="disabled"
          />
        </el-col>
      </el-row>

      <el-button
        v-if="!readonly"
        :disabled="disabled"
        type="primary"
        icon="el-icon-plus"
        @click="addParam"
        class="add-button"
      >
        {{ $t('UrlTracking_AddParam') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import Toggle from '@/common/components/form/Toggle'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'UrlTrackingParameters',

  components: {
    RestFormItem,
    Toggle
  },

  props: {
    model: {
      type: Object,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {}
  },

  computed: {
    readonly() {
      return !this.$can('manageProjectTechnical')
    },
    gaSource() {
      return this.$store.state.app.project.provider['source']
        ? this.$store.state.app.project.provider['source']
        : ''
    },
    gaTerm() {
      return this.$store.state.app.project.provider['term']
        ? this.$store.state.app.project.provider['term']
        : ''
    },
    utmParamsList() {
      return [
        {
          key: 'utm_source',
          value: this.gaSource
        },
        {
          key: 'utm_medium',
          value: '{{ message.channel }}'
        },
        {
          key: 'utm_campaign',
          value: `{{ campaign.name }} (${this.gaSource} #{{ campaign.id }})`
        },
        {
          key: 'utm_term',
          value: `${this.gaTerm} #{{ trigger.id }}_{{ device.id }}`
        },
        {
          key: 'utm_content',
          value: '{{ message.variant }}'
        }
      ]
    }
  },

  methods: {
    removeParam(index) {
      this.model.params.filter(item => item.id !== index)
      this.model.params.splice(index, 1)
    },

    addParam() {
      this.model.params.push({ key: '', value: '' })
    }
  }
}
</script>

<style scoped>
.utm-params-list {
  font-size: 12px;
  margin-top: -10px;
  margin-bottom: 20px;
}

.utm-params-list.disabled {
  color: #c0c4cc;
}

.utm-params-list >>> td {
  padding: 6px 0;
}

.custom-params-list .remove-button {
  display: block;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/UrlTrackingParameters.vue